import React from "react";
import { Box, Typography } from "@mui/material";
import { typeVariant } from "../../config/theme";

interface SectionHeaderProps {
  title: string;
  icon?: React.ReactNode;
  /** Short helper text rendered below the title. */
  subtitle?: string;
  /** Right-aligned action area (buttons, toggles, download). */
  action?: React.ReactNode;
}

/**
 * Consistent section/card header: optional leading icon + title (heading
 * token) + optional subtitle, with an optional right-aligned action slot.
 */
export default function SectionHeader({ title, icon, subtitle, action }: SectionHeaderProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: subtitle ? "flex-start" : "center",
        justifyContent: "space-between",
        gap: 1.5,
        mb: 1.5,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
        {icon && (
          <Box sx={{ display: "flex", color: "text.secondary", flexShrink: 0 }}>{icon}</Box>
        )}
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ ...typeVariant("heading"), color: "text.primary" }}>{title}</Typography>
          {subtitle && (
            <Typography variant="caption" sx={{ color: "text.secondary", display: "block", mt: 0.25 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>
      {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
    </Box>
  );
}
